import { apiGetProvinces } from "../api/apiGetProvinces";

const initialState = {
    list: [],
    isRequesting: false,
    municipality: null,
    residenceMunicipality: null,
    gasSupplyMunicipality: null
};

export const MUNICIPALITY_FIELDS = {
    municipality: 'municipality',
    residence: 'residenceMunicipality',
    gas: 'gasSupplyMunicipality'
}

const PROVINCES_SET = 'PROVINCES_SET';
function provincesSet(provinces) {
    return { type: PROVINCES_SET, provinces };
}

const PROVINCES_REQUEST_START = 'PROVINCES_REQUEST_START';
const provincesRequestStart = () => ({ type: PROVINCES_REQUEST_START });

const PROVINCES_REQUEST_END = 'PROVINCES_REQUEST_END';
const provincesRequestEnd = () => ({ type: PROVINCES_REQUEST_END });

const PROVINCES_SET_MUNICIPALITY = 'PROVINCES_SET_MUNICIPALITY';
export function provincesSetMunicipality(municipality, municipalityType = MUNICIPALITY_FIELDS.municipality) {
    return { type: PROVINCES_SET_MUNICIPALITY, municipality, municipalityType };
}

export function provincesGet(search) {
    return async (dispatch, getState) => {
        const { provinces: provincesState } = getState();
        if (provincesState.isRequesting) return;
        dispatch(provincesRequestStart());
        try {
            const provinces = await apiGetProvinces(search);
            dispatch(provincesSet(provinces));
        } catch (error) {
            
        } finally {
            dispatch(provincesRequestEnd());
        } 
    }
}

export function provincesReducer(state = initialState, action) {
    switch (action.type) {
        case PROVINCES_SET: {
            return { ...state, list: action.provinces };
        }
        case PROVINCES_REQUEST_START: {
            return { ...state, isRequesting: true }
        }
        case PROVINCES_REQUEST_END: {
            return { ...state, isRequesting: false }
        }
        case PROVINCES_SET_MUNICIPALITY: {
            return { ...state, [action.municipalityType]: action.municipality }
        }
        default:
            return state;
    }
}